function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 21,
  width: 23,
  height: 2,
  rx: 1
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.217 18.76a1 1 0 01-1.435.002l-5.49-5.64a1 1 0 111.415-1.415l3.768 3.768V3a1 1 0 112 0v12.475l3.762-3.762a1.008 1.008 0 011.436 1.414l-5.456 5.633z"
});

function SvgVerticalAlignBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMjEiIHdpZHRoPSIyMyIgaGVpZ2h0PSIyIiByeD0iMSIvPgo8cGF0aCBkPSJNMTIuMjE2NiAxOC43NjAxQzExLjgyNDMgMTkuMTY1MiAxMS4xNzQ5IDE5LjE2NTkgMTAuNzgxNiAxOC43NjE4TDUuMjkyODkgMTMuMTIxM0M0LjkwMjM3IDEyLjczMDggNC45MDIzNyAxMi4wOTc2IDUuMjkyODkgMTEuNzA3MUM1LjY4MzQyIDExLjMxNjUgNi4zMTY1OCAxMS4zMTY1IDYuNzA3MTEgMTEuNzA3MUwxMC40NzQ5IDE1LjQ3NDlMMTAuNDc0OSAzQzEwLjQ3NDkgMi40NDc3MiAxMC45MjI2IDIgMTEuNDc0OSAyQzEyLjAyNzIgMiAxMi40NzQ5IDIuNDQ3NzIgMTIuNDc0OSAzVjE1LjQ3NTJMMTYuMjM3MiAxMS43MTI4QzE2LjYzMDcgMTEuMzE5MyAxNy4yNjg3IDExLjMxOTMgMTcuNjYyMiAxMS43MTI4QzE4LjA1MTQgMTIuMTAyMSAxOC4wNTYyIDEyLjczMTcgMTcuNjcyOSAxMy4xMjY5TDEyLjIxNjYgMTguNzYwMVoiIC8+Cjwvc3ZnPgo=";
export { SvgVerticalAlignBottom as ReactComponent };